import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './ProgressBar.css';

function ProgressBar(props) {
    const { current, total, onClick } = props;

    const percentage = total ? Math.floor(current * 100 / total) : 100;
    const label = `${current} / ${total} - ${percentage}%`;

    const styleWidth = Math.min(100, percentage);
    const containerClasses = classNames('progress', {
        'cursor-pointer': onClick,
    });

    return (
        <div className={containerClasses} onClick={onClick}>
            <div
              role="progressbar"
              className="progress-bar progress-bar-info"
              aria-valuenow={current}
              aria-valuemin={0}
              aria-valuemax={total}
              style={{ width: `${styleWidth}%` }}
            />
            <div className="progress-bar-label">{label}</div>
        </div>
    );
}

ProgressBar.PropTypes = {
    current: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    onClick: PropTypes.func,
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/widgets/ProgressBar.js